import { HttpClient } from '@angular/common/http';
import {
  Injectable,
  ModuleWithProviders,
  NgModule,
  inject,
} from '@angular/core';
import {
  TRANSLOCO_LOADER,
  Translation,
  TranslocoLoader,
  TranslocoModule,
  provideTransloco,
} from '@ngneat/transloco';
import { provideTranslocoMessageformat } from '@ngneat/transloco-messageformat';
import { environment } from './environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  private env = inject(environment);

  getTranslation(lang: string) {
    return this.http.get<Translation>(
      `${this.env.resourceStringUrl}/${lang}.json`,
    );
  }
}

@NgModule({
  exports: [TranslocoModule],
})
export class TranslationModule {
  public static forRoot(env): ModuleWithProviders<TranslationModule> {
    return {
      ngModule: TranslationModule,
      providers: [
        { provide: environment, useValue: env },
        provideTransloco({
          config: {
            availableLangs: ['sv', 'en'],
            defaultLang: 'sv',
            // Remove this option if your application
            // doesn't support changing language in runtime.
            reRenderOnLangChange: true,
            prodMode: env.production,
          },
          loader: TranslocoHttpLoader,
        }),
        { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader },
        provideTranslocoMessageformat(),
      ],
    };
  }
}
